import React from 'react';
import { useFilters } from '../../hooks/useFilters';
import AgeRange from '../Common/AgeRange';

const AgeFilter = () => {
  const { filters, updateFilter } = useFilters();
  const minValue = Number.isInteger(filters.age_min) ? filters.age_min : 0;
  const maxValue = Number.isInteger(filters.age_max) ? filters.age_max : 12;

  return (
    <AgeRange
      minValue={minValue}
      maxValue={maxValue}
      onChange={(min, max) => { updateFilter('age_min', min); updateFilter('age_max', max); }}
    />
  );
};

export default AgeFilter;
